import React, { Component } from "react";
import { Field, Form, Formik } from "formik";
import { FormGroup, Label, Button } from "reactstrap";
import { SimpleInput, DefaultObject } from "@gsd/backoffice-ui";

import * as Yup from "yup";

const ValidateSchema = Yup.object().shape({
  apiKey: Yup.string().required("Campo obbligatorio"),
  name: Yup.string().required("Campo obbligatorio"),
  rolePrefix: Yup.string().required("Campo obbligatorio"),
});

type FormProps = {
  onSubmit: Function;
  initialValues: {
    uid: number;
    apiKey: string;
    name: string;
    redirectUrl: string;
    rolePrefix: string;
  };
};

export default class FormApplication extends Component<FormProps> {
  static defaultProps: Partial<FormProps> = {
    onSubmit: (values) => {
      console.log(values);
    },
  };

  render() {
    const { initialValues } = this.props;
    const defaultValues = {
      uid: 0,
      apiKey: "",
      name: "",
      redirectUrl: "",
      rolePrefix: "",
    };

    const formValues = DefaultObject(initialValues, defaultValues);
    return (
      <Formik
        initialValues={formValues}
        validationSchema={ValidateSchema}
        onSubmit={this.props.onSubmit as any}
      >
        {(formmikProps) => {
          return (
            <Form>
              <input type="hidden" value="testing" name="uid" />
              <FormGroup>
                <Label for="apiKey">
                  apiKey
                  <span className="text-primary">*</span>
                </Label>
                <Field name="apiKey" type={"text"} component={SimpleInput} />
              </FormGroup>
              <FormGroup>
                <Label for="name">
                  name
                  <span className="text-primary">*</span>
                </Label>
                <Field name="name" type={"text"} component={SimpleInput} />
              </FormGroup>
              <FormGroup>
                <Label for="redirectUrl">redirectUrl</Label>
                <Field
                  name="redirectUrl"
                  type={"text"}
                  component={SimpleInput}
                />
              </FormGroup>
              <FormGroup>
                <Label for="rolePrefix">
                  rolePrefix
                  <span className="text-primary">*</span>
                </Label>
                <Field
                  name="rolePrefix"
                  type={"text"}
                  component={SimpleInput}
                />
              </FormGroup>
              <div className="text-center">
                <Button
                  color="primary"
                  size="lg"
                  className="px-5"
                  type="submit"
                  disabled={!formmikProps.isValid || formmikProps.isSubmitting}
                >
                  Salva
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    );
  }
}
